import moment from 'moment'

import { ampmTimeDisabler } from './util'

export const depotCreateConfig = (selectOptions) => {
  return [
    {
      step_title: 'Name',
      form_title: 'Identify Depot',
      section: [
        {
          name: 'name',
          type: 'text',
          input: 'input',
          placeholder: 'Enter Name',
          rules: [
            {
              required: true,
              message: 'Depot name is required',
            },
          ],
        },
        {
          name: 'supervisor',
          type: 'text',
          input: 'input',
          placeholder: 'Enter Depot Supervisor',
        },
        {
          name: 'market',
          input: 'select',
          type: 'single',
          placeholder: 'Select Market',
          options: selectOptions.marketOptions,
          rules: [
            {
              required: true,
              message: 'Market is required',
            },
          ],
        },
        {
          name: 'sector',
          input: 'select',
          type: 'single',
          placeholder: 'Select Sector',
          options: selectOptions.sectorOptions,
        },
      ],
    },
    {
      step_title: 'Location',
      form_title: 'Terminal Location',
      section: [
        {
          name: 'address',
          input: 'input',
          type: 'text',
          placeholder: 'Enter Address',
        },
        {
          name: 'city',
          type: 'text',
          input: 'input',
          placeholder: 'Enter City',
        },
        {
          name: 'state',
          input: 'select',
          type: 'single',
          placeholder: 'Select State',
          options: selectOptions.stateAbbreviations,
        },
        {
          name: 'latitude',
          input: 'inputNumber',
          min: -90,
          max: 90,
          precision: 5,
          placeholder: 'Enter Latitude',
          rules: [
            {
              required: true,
              message: 'latitude is required',
            },
          ],
        },
        {
          name: 'longitude',
          input: 'inputNumber',
          min: -180,
          max: 180,
          precision: 5,
          placeholder: 'Enter Longitude',
          rules: [
            {
              required: true,
              message: 'Longitude is required',
            },
          ],
        },
        {
          name: 'service_radius',
          input: 'inputNumber',
          min: 0,
          max: 3000,
          precision: 0,
          placeholder: 'Enter Service Radius',
          rules: [
            {
              required: true,
              message: 'Service Radius is required',
            },
          ],
        },
      ],
    },
    {
      step_title: 'Start Times',
      form_title: 'Default Start Times',
      section: [
        {
          name: 'am_shift_start_time',
          input: 'time',
          placeholder: 'Select a default shift start time',
          disabledTime: () => ampmTimeDisabler('am'),
          use12Hours: true,
          minuteStep: 15,
          format: 'h:mm a',
        },
        {
          name: 'pm_shift_start_time',
          input: 'time',
          placeholder: 'Select a default shift end time',
          disabledTime: () => ampmTimeDisabler('pm'),
          hideDisabledOptions: true,

          minuteStep: 15,
          format: 'h:mm a',
        },
      ],
    },
  ]
}
